import { ProductResult } from "~/models/Product"
import { PageKey } from "~/models/Page"

type Sum = {
  initPrice: number,
  initCost: number,
  price: number
}

export const SummaryKey = {
  ...PageKey,
  Total: "total",
  Service: "service"
} as const

export type SummaryType = typeof SummaryKey[keyof typeof SummaryKey]

type SummaryProduct = {
  contract: number,
  charge: number,
} & ProductResult

type Subtotal = {
  key: SummaryType
  title: string
  items: SummaryProduct[]
  sum: Sum
}
export type Summary = {
  total: Sum,
  subtotals: Subtotal[]
}
